import {
    MeetingServiceOrderDeliveryDetails,
    MeetingServiceOrderMeetingDetails,
} from "../../merchant/accounting/accounting/accountingTypes"

export enum OutlookSessionType {
    OUTLOOK_MEETING = "OUTLOOK_MEETING",
}

export type OutlookBookingSuccessArgs = Readonly<{
    orderId: number
    startDateTime: string // YYYY-MM-DD HH:mm
    endDateTime: string // YYYY-MM-DD HH:mm
    meetingLocation: string
}>

export type OutlookSession = Readonly<{
    uid: string
    user: {
        id: number
    }
    values: SessionValue[]
}>

export type SessionValue = OutlookMeetingValue | OtherSessionValue

type OtherSessionValue = {
    type: string
}

export type OutlookMeetingValue = Readonly<{
    type: OutlookSessionType.OUTLOOK_MEETING
    order: OutlookSessionOrder
}>

type OutlookMeetingDetails = Omit<MeetingServiceOrderMeetingDetails, "location"> & {
    location: string
    calendarAppointmentId: string
    /** Non-PII headcount of Outlook attendees; gates the "share Outlook attendees" opt-in toggle. */
    outlookAttendeeCount?: number
}

export type OutlookSessionOrder = Readonly<{
    meetingDetails?: OutlookMeetingDetails
    deliveryDetails?: DeliveryDetails
}>

type DeliveryDetails = Readonly<{
    time: MeetingServiceOrderDeliveryDetails["time"]
    sittings?: MeetingServiceOrderDeliveryDetails["sittings"]
}>
